/** Two button roles for the whole app; plain data so Paper-free code can use it. */
export const BUTTON_COLORS = {
  // Primary: #121212 on #EAEAEA is 15.6:1
  primaryBg: "#EAEAEA",
  primaryText: "#121212",
  // Secondary: #EAEAEA label, #8A8A8A border (4.8:1 on the #1E1E1E surface)
  secondaryText: "#EAEAEA",
  secondaryBorder: "#8A8A8A",
} as const;
